import { Directive, Input, TemplateRef } from '@angular/core';

export interface NiTableCellContext<T = unknown> {
  $implicit: T;
  row: T;
  value: unknown;
}

@Directive({
  selector: '[niTableCell]',
  standalone: true,
})
export class NiTableCellDirective<T = unknown> {
  @Input({ alias: 'niTableCell', required: true }) columnKey!: string;

  constructor(public readonly templateRef: TemplateRef<NiTableCellContext<T>>) {}
}
